import { render, staticRenderFns } from "./OurAdvantages.vue?vue&type=template&id=3deec166&"
import script from "./OurAdvantages.vue?vue&type=script&lang=js&"
export * from "./OurAdvantages.vue?vue&type=script&lang=js&"
import style0 from "./OurAdvantages.vue?vue&type=style&index=0&id=3deec166&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports